import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";
import React from "react";
import { logEvent } from "../../helper/AppInsightsHelper";
import { ExploreDataButtonWithDialog } from "../ExploreDataButtonWithDialog";
import { CustomDataGridFooterProps } from "../Interfaces/CustomDataGrid.interfaces";

export const CustomDataGridFooter: React.FC<CustomDataGridFooterProps> = ({
  showExploreDataButton = true,
  kustoLink,
  loading,
  TabName
}) => (
  <GridFooterContainer sx={!showExploreDataButton ? { justifyContent: "flex-end", display: "flex" } : undefined}>
    {showExploreDataButton && (
      <ExploreDataButtonWithDialog
        query={kustoLink || ""}
        onRedirectComplete={() =>
          logEvent(
            `Explore Data Button Clicked on ${TabName ?? "custom data grid"}`,
            "CustomDataGrid",
            "CustomDataGridFooter",
            {
              TabName: TabName ?? "custom data grid",
              KustoLink: kustoLink || ""
            }
          )
        }
        disabled={!kustoLink}
      />
    )}
    <GridPagination
      sx={
        loading
          ? {
              "& .MuiTablePagination-actions button": {
                pointerEvents: "none",
                opacity: 0.5
              }
            }
          : undefined
      }
    />
  </GridFooterContainer>
);
